<!--component html goes here -->
  <!-- Hero Start -->
<app-header></app-header>

<!-- <section class="bg-half-170 bg-light d-table w-100" style="background: url('assets/images/EventImag.jpg') center center;" id="home">
  <div class="bg-overlay"></div>
  <div class="container " >
          <div class="col-lg-12 text-center">
              <div class="pages-heading">
                  <h4 class="title text-white title-dark mb-0"> Events Worled </h4>
              </div>
          </div> 
      <div class="position-breadcrumb">
          <nav aria-label="breadcrumb" class="d-inline-block">
              <ul class="breadcrumb rounded shadow mb-0 px-4 py-2">
                  <li class="breadcrumb-item"><a routerLink="">Blimp</a></li>
                  <li class="breadcrumb-item"><a routerLink="/events-world">Events</a></li>
              </ul>
          </nav>
      </div>
  </div>
</section> -->
<!--end section-->
<!-- Hero End -->

<!-- Shape Start -->
<!-- <div class="position-relative">
  <div class="shape overflow-hidden text-color-white">
      <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
      </svg>
  </div>
</div> -->
<!--Shape End-->

<!-- Blog STart -->
<section class="bg-half" id="home" >
  <div class="container">
    <div class="row justify-content-center">
        <div class="col-12">
            <div class="section-title text-center mb-4 pb-2">
                <h4 ><span class="text-primary">Events world</span></h4>
                <p class="text-muted para-desc mx-auto mb-0">All <span
                        class="text-primary fw-bold">events</span> that may interest you around the world</p>
            </div>
        </div>
        <!--end col-->
        
    </div>
    <div class="row justify-content-center">
        <div class="col-lg-8 col-md-6 mb-4 pb-2">
          <form class="p-4 shadow rounded">
            <h4 class="mb-3">Search</h4>
            <div class="row text-start">
              <div class="col-lg-3 col-md-6">
                <div class="mb-3 mb-lg-0">
                  <label class="form-label"> From Date : </label>
                  <input type="text" class="form-control" name="picker" id="checkin" [(ngModel)]="fromDate" [ngModelOptions]="{standalone: true}" mwlFlatpickr
                  [altInput]="true" [convertModelValue]="true">
                </div>
              </div>
              <!--end col-->
  
              <div class="col-lg-3 col-md-6">
                <div class="mb-3 mb-lg-0">
                  <label class="form-label"> To : </label>
                  <input type="text" class="form-control" name="checkoutpicker" id="checkout" [(ngModel)]="toDate"[ngModelOptions]="{standalone: true}"
                  [altInput]="true" mwlFlatpickr [convertModelValue]="true">
                </div>
              </div>
              <!--end col-->
              <div class="col-lg-6">
                <div class="row align-items-center">
                  <div class="col-md-6">
                    <div class="mb-3 mb-lg-0">
                      <label class="form-label">Country : </label>
                      <div >
                        <div class="d-flex justify-content-md-between align-items-center">
                            <div class="form custom-form">
                                <div class="mb-0">
                                    <select  placeholder="Selecte Country" [(ngModel)]="countryId" [ngModelOptions]="{standalone: true}" class="form-select form-control" aria-label="Default select example" id="Sortbylist-job">
                                        <option [value]="0">All</option>
                                        <option  *ngFor="let data of CountriesList" [value]="data.id">{{data.nameEn}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div><!--end col-->
                      <!-- <input type="text" min="0" autocomplete="off" id="adult" required="" class="form-control"
                        placeholder="City :"> -->
                    </div>
                  </div>
                  <!--end col-->
                  <div class="col-md-6 mt-lg-4 pt-2 pt-lg-1">
                    <div class="d-grid">
                      <input type="submit" id="search" name="search" class="searchbtn btn btn-primary" value="Search" (click)="Search()">
                    </div>
                  </div>
                  <!--end col-->
                </div>
              </div>
            </div>
          </form>
        </div>
        <!--end col-->
    </div>
    <div class="row justify-content-center" *ngIf="rows==null||rows.length == 0">
            <html>
                <head>
                <meta name="viewport" content="width=device-width, initial-scale=1">
                <style>
                .loader {
                    position: absolute;
                    left: 50%;
                    top: 50%;
                    z-index: 1;
                    width: 60px;
                    height: 60px;
                    margin: -76px 0 0 -76px;
                    border: 16px solid #f3f3f3;
                    border-radius: 50%;
                    border-top: 16px solid #3498db;
                    -webkit-animation: spin 2s linear infinite;
                    animation: spin 2s linear infinite;
                }
                
                /* Safari */
                @-webkit-keyframes spin {
                  0% { -webkit-transform: rotate(0deg); }
                  100% { -webkit-transform: rotate(360deg); }
                }
                
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
                </style>
                </head>
                <body>
                <div class="loader"></div>
                
                </body>
             </html>
    </div>
      <div class="row justify-content-center">
          <div class="col-lg-4 col-md-6 mb-4 pb-2" *ngFor="let data of rows">
              <div class="breadcrumb-item card blog rounded border-0 shadow overflow-hidden" style="width: 319px; height: 306px;"  (click)="EventDetails(data.id)">
                  <div class="position-relative" >
                      <img src="{{data.images}}" class="card-img-top" alt="..." width="319px" height="175px">
                  </div>
                  <div class="card-body content">
                      <h5><a href="javascript:void(0)" class="card-title title text-dark">{{data.titleEn}}</a></h5>
                      <div class="post-meta d-flex justify-content-between mt-3">
                          <ul class="list-unstyled mb-0">
                              <!-- <li class="list-inline-item me-2 mb-0"><a href="javascript:void(0)"
                                      class="text-muted like"><i class="uil uil-heart me-1"></i>{{data.like}}</a></li> -->
                                      <li >
                                            <ngb-rating [max]="5" [(rate)]="data.averageStar" [readonly]="true" style="font-size: 25px;">
                                            </ngb-rating>
                                        </li>
                              <!-- <li class="list-inline-item"><a href="javascript:void(0)" class="text-muted comments"><i
                                          class="uil uil-comment me-1"></i>{{data.message}}</a></li> -->
                          </ul>
                          <ul class="list-unstyled mb-0">
                            <li (click)="EventDetails(data.id)" class="list-inline-item text-muted readmore">Read More 
                                <i class="uil uil-angle-right-b align-middle"></i>
                            </li>
                     
                          </ul>
                 
                      </div>
                     
                  </div>
                  <div class="author">
                      <small class="text-light user d-block"><i class="uil uil-user"></i> {{data.titleEn}}</small>
                      <small class="text-light date"><i class="uil uil-calendar-alt"></i> {{data.date| date:'dd/MM/y'}}</small>
                  </div>
              </div>
          </div>
          <!--end col-->

          <!-- PAGINATION START -->
          <div class="col-12">
              <ul class="pagination justify-content-center mb-0">
                  <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Previous">Prev</a>
                  </li>
                  <li class="page-item active"><a class="page-link" href="javascript:void(0)">1</a></li>
                  <li class="page-item"><a class="page-link" href="javascript:void(0)">2</a></li>
                  <li class="page-item"><a class="page-link" href="javascript:void(0)">3</a></li>
                  <li class="page-item"><a class="page-link" href="javascript:void(0)" aria-label="Next">Next</a></li>
              </ul>
          </div>
          <!--end col-->
          <!-- PAGINATION END -->
      </div>
      <!--end row-->
  </div>
  <!--end container-->
</section>
<!--end section-->
<!-- Blog End -->

<!-- Back to top -->
<a href="javascript: void(0);" class="btn btn-icon btn-primary back-to-top" id="back-to-top" [ngxScrollTo]="'#home'">
  <i-feather name="arrow-up" class="icons"></i-feather>
</a>
<!-- Back to top -->
 